@if (!floatingIncentive()) {
  <ng-container *ngTemplateOutlet="labels"></ng-container>
}
<div class="d-flex flex-row">
  <div class="d-flex flex-column flex-grow-1">
    @if (floatingIncentive()) {
      <ng-container *ngTemplateOutlet="floatingLabels"></ng-container>
    }
    <span class="offer-card-header__title mb-0" wlCSCapture>{{
      duration()
    }}</span>
    <span class="secondary-text" wlCSCapture>
      @if (
        enableNewOfferCardTitles() &&
        (isDynamicProduct() || duration() === 'flex')
      ) {
        {{ productTitle() }} - {{ duration() }}
      } @else {
        {{ productTitle() }}
      }
    </span>
  </div>
  @if (showPriceTag()) {
    <div class="d-flex flex-column ms-1 text-end">
      @if (price(); as price) {
        <span class="offer-card-header__budgetbillamount mb-0" wlCSCapture>{{
          price | roundedCurrency
        }}</span>
      }
      <span class="small-text text-end" wlCSCapture
        >{{ priceDurationLabel() }}
        @if (
          incentive() && (termijnbedragVariantA() || termijnbedragVariantB())
        ) {
          {{ withDiscountAlternateLabel() }}
        }
      </span>
    </div>
  }
</div>

<ng-template #labels>
  <!-- optional spacer to make sure items on full card view can be aligned horizontally -->
  @if (addLabelSpacer() && !highlight() && !incentive()) {
    <ng-container *ngTemplateOutlet="spacer"></ng-container>
  }
  <div class="d-flex">
    @if (highlight(); as highlight) {
      <wl-commodity-offer-label
        [style]="'highlight'"
        [label]="highlight"
      ></wl-commodity-offer-label>
    }
    @if (incentive(); as incentive) {
      <wl-commodity-offer-label
        [style]="'incentive'"
        [label]="incentive"
        [class.ms-1]="!!highlight()"
      ></wl-commodity-offer-label>
    }
  </div>
</ng-template>

<ng-template #floatingLabels>
  <!-- optional spacer to make sure items on full card view can be aligned horizontally -->
  @if (addLabelSpacer() && !highlight()) {
    <ng-container *ngTemplateOutlet="spacer"></ng-container>
  }
  @if (highlight(); as highlight) {
    <wl-commodity-offer-label
      [style]="'text'"
      [label]="highlight"
    ></wl-commodity-offer-label>
  }

  <div class="offer-card-header__incentive--floating">
    @if (incentive(); as incentive) {
      <wl-commodity-offer-label
        class="flex-shrink-0"
        [style]="'incentive'"
        [label]="incentive"
      ></wl-commodity-offer-label>
    }

    @if (promoCode(); as promoCode) {
      <wl-commodity-offer-label
        [style]="'promocode'"
        [label]="promoCode"
      ></wl-commodity-offer-label>
    }
  </div>
</ng-template>

<ng-template #spacer>
  <div
    [ngStyle]="{
      visibility: 'visible',
      height: '21px',
    }"
  ></div>
</ng-template>
